export const getInterventionZoneByInterventionId = (interventionZones, interventionId) => interventionZones
  .find(iz => iz.interventions
    .some(i => i.id === interventionId));